import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CaremapNotesModelFactory } from '../notes/model/CaremapNotesModelFactory';
import { QueryParamDrivenDrawerHelper } from '../components/query-param-driver-drawer/QueryParamDrivenDrawerHelper';
import { IonFooter } from '@ionic/react';
import { CommentEditor } from '../comments/CommentEditor';

export const CommunityPostFooter: React.FC<{
    parentNoteId: string;
    autoFocus?: boolean;
}> = ({ parentNoteId, autoFocus }) => {

    const factory = useInstance(CaremapNotesModelFactory);
    useSubscription(() => factory);

    const drawerHelper = useInstance(QueryParamDrivenDrawerHelper);

    const noteModel = factory.forActiveCaremap();
    const note = noteModel.getNote(parentNoteId);

    if (!note) {
        return null;
    }

    const onNotFound = () => {
        noteModel.localDeleteNote(note);
        drawerHelper.close();
    };

    return (
        <IonFooter style={{padding: 8, paddingLeft: 12}}>
            <CommentEditor
                note={note}
                onNotFound={onNotFound}
                autoFocus={autoFocus}
            />
        </IonFooter>
    );
};
